import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'mobx-react';
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import history from 'utils/history';

import App from './App';
import GlobalStore from './models';

const globalStore = new GlobalStore();

history.listen((location, action) => {
    if (action === 'PUSH') {
        window.scroll(0, 0);
    }
});

ReactDom.render(
    <Provider globalStore={globalStore}>
        <LocaleProvider locale={zh_CN}>
            <App history={history} />
        </LocaleProvider>
    </Provider>,
    document.getElementById('app')
);
